import { memo } from 'react';

import * as E from '@pages/Equipment/Equipment.style';
import theme from '@styles/theme';
import NO_IMAGE from '@assets/images/empty.png';

import { FlexBox, RegularFont } from '@components/styled/StyledComponents';
import StyledCheckbox from '@components/styled/StyledCheckbox';

type BannerListRowProps = {
    name: string;
    data: any;
    list: any[];
    optionLists: any[];
    sectionIndex: number;
    toggleCheckbox: (sectionKey: string, value: any, options: any[]) => void;
    imgAspect?: number;
};
const BannerListRow = ({
    name,
    data,
    list = [],
    optionLists = [],
    sectionIndex,
    toggleCheckbox,
    imgAspect
}: BannerListRowProps) => {
    if (data.notice) {
        return (
            <E.PlayListRow>
                <StyledCheckbox
                    checkboxId={`${name}-${data?.id}`}
                    name={name}
                    value={data?.id}
                    onChange={() =>
                        toggleCheckbox(
                            `section${sectionIndex + 1}`,
                            data,
                            optionLists
                        )
                    }
                    checked={
                        !!list.filter((list) => list?.id === data?.id).length
                    }
                    margin="0 0 20px"
                    gap={10}
                    SQUARE
                />
                <E.NoticeContent>{data.notice}</E.NoticeContent>
            </E.PlayListRow>
        );
    }
    return (
        <E.PlayListRow>
            <StyledCheckbox
                checkboxId={`${name}-${data?.id}`}
                name={name}
                value={data?.id}
                onChange={() =>
                    toggleCheckbox(
                        `section${sectionIndex + 1}`,
                        data,
                        optionLists
                    )
                }
                checked={!!list.filter((list) => list?.id === data?.id).length}
                margin="0 0 20px"
                gap={10}
                SQUARE
            />
            <E.Thumbnail
                src={`${data?.img}/${(imgAspect as number) > 1 ? 83 : 44}/${
                    (imgAspect as number) >= 1 ? 44 : 85
                }`}
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                    e.currentTarget.src = NO_IMAGE;
                }}
                alt="썸네일"
                $width={(imgAspect as number) > 1 ? 83 : 44}
                $height={(imgAspect as number) >= 1 ? 44 : 85}
            />
            <FlexBox $flexDirection="column" $alignItems="flex-start">
                <E.MediaTitle>{data?.filename}</E.MediaTitle>
                <RegularFont
                    $fontColor={theme.colors.deepGrayFontColor}
                    $fontSize={12}
                >
                    ({data?.filesize}MB)
                </RegularFont>
            </FlexBox>
        </E.PlayListRow>
    );
};

export default memo(BannerListRow);
